import React from 'react';
import { Edit, SimpleForm, TextInput, NumberInput } from 'react-admin';
import { S3FileInput } from './aws/S3FileInput';
import { S3ImageInput } from './aws/S3ImageInput';

export default (props) => (
  <Edit {...props}>
    <SimpleForm redirect="show">
      <TextInput source="name" />
      <NumberInput source="order" />
      <S3FileInput
        source="video"
        accept="video/*"
        multiple={false}
        keyPrefix="stage-video/"
      />
      <S3ImageInput
        source="poster"
        accept="image/*"
        multiple={false}
        keyPrefix="stage-poster/"
      />
    </SimpleForm>
  </Edit>
);
